import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import Form from './form';
import Grid from './grid';
import UploadStatus from './uploadstatus';
import { hasDuplicates } from '../../utils/util';
import { getSession } from '../../global';

const RetailBulkBooking = () => {
    const state = useSelector(state => { return { appData: state.appData, bulkBookingData: state.bulkBookingData } });
    const { userInfo, destinations } = state.appData;
    const { grid, gridStatus, data } = state.bulkBookingData;
    const history = useHistory();
    const dests = destinations.map(x => x.text);

    const myWorker = React.useRef(new Worker('./bulkwebworker.js'));
    let worker = myWorker.current;
    useEffect(() => {
        if (!worker) {
            worker = new Worker('./bulkwebworker.js')
        }
        return () => {
            worker.terminate();
            worker = null;
        }
    }, [])

    useEffect(() => {
        if (!valdiatePage('/retailbulkbooking')) {
            history.push('/login');
        }
    }, []);

    const validateExcel = (fromWhere) => {
        if (!data.subAccountId) {
            alert('Select Sub Account');
            return false;
        }

        if (!data.locationId) {
            alert('Select Location');
            return false;
        }

        if (data.autoCN === false) {
            if (grid.filter(x => !x.ConsignmentNo).length > 0) {
                alert('Consignment No is required');
                return false;
            } else {
                const cns = grid.map(x => x.ConsignmentNo);
                if (hasDuplicates(cns)) {
                    alert('Duplicate Consignment No are not allowed');
                    return false;
                } else {
                    const sequnce = getSession('sequences').filter(x => x.locationId == data.locationId)[0];
                    const start = Number(sequnce.sequenceStart);
                    const end = Number(sequnce.sequenceEnd);
                    for (const x of grid) {
                        let num = Number(x.ConsignmentNo);
                        if (!(num >= start && num <= end)) {
                            alert(`Invalid Consignment# ${num}`);
                            return false;
                        }
                    }
                }
            }
        }

        if (grid.filter(x => !x.ConsigneeName || x.ConsigneeName.trim() == '').length > 0) {
            alert('Consignee Name is required');
            document.getElementById(`errorDiv`).focus()
            return false;
        }

        if (grid.filter(x => !x.ConsigneeAddress || x.ConsigneeAddress.trim() == '').length > 0) {
            alert('Consignee Address is required');
            document.getElementById(`errorDiv`).focus()
            return false;
        }

        if (grid.filter(x => !x.DestinationCity || !dests.map(y => y.toUpperCase()).includes(x.DestinationCity.toUpperCase())).length > 0) {
            alert('Destination is required');
            document.getElementById(`errorDiv`).focus()
            return false;
        }

        if (grid.filter(x => !x.Pieces || x.Pieces <= 0).length > 0) {
            alert('Pieces is required');
            document.getElementById(`errorDiv`).focus()
            return false;
        } else {
            if (grid.filter(x => x.Pieces > 99).length > 0) {
                alert('Pieces must be less than or equals to 99');
                document.getElementById(`errorDiv`).focus()
                return false;
            }
        }

        if (grid.filter(x => !x.Weight || x.Weight <= 0).length > 0) {
            alert('Weight is required');
            document.getElementById(`errorDiv`).focus()
            return false;
        } else {
            const w = data.isCod ? 99 : 9999;
            if (grid.filter(x => x.Weight > w).length > 0) {
                alert('Weight must be less than or equals to ' + w);
                document.getElementById(`errorDiv`).focus()
                return false;
            }
        }

        if (data.isCod) {

            if (!userInfo.isZeroCodAllowed) {
                if (grid.filter(x => x.CODAmount.trim() == '' || x.CODAmount <= 0).length > 0) {
                    alert('0 Cod amount not allowed');
                    document.getElementById(`errorDiv`).focus()
                    return false;
                }
            }

            if (grid.filter(x => x.CODAmount.trim() > 99999).length > 0) {
                alert('COD amount must be less than or equals to 99999');
                document.getElementById(`errorDiv`).focus()
                return false;
            }

            if (grid.filter(x => !x.CustomerReferenceNumber || x.CustomerReferenceNumber.trim() == '').length > 0) {
                alert('Customer Reference Number not found');
                document.getElementById(`errorDiv`).focus()
                return false;
            }
        }

        if (!userInfo.isDuplicateOrderAllowed) {
            const refno = grid.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => x.CustomerReferenceNumber);
            if (hasDuplicates(refno)) {
                alert('Duplicate CustomerReferenceNumber not allowed');
                document.getElementById(`errorDiv`).focus()
                return false;
            }
        }

        if (grid.filter(x => !x.ServiceType || !['Overnight'.toUpperCase(), 'Second Day'.toUpperCase()].includes(x.ServiceType.toUpperCase())).length > 0) {
            document.getElementById(`errorDiv`).focus()
            alert('Valid Service Type is required');
            return false;
        }

        if (fromWhere === "save") {
            if (!data.tarrifLoaded) {
                alert('Please Load Tarrif First.');
                return false;
            }

            if (grid.filter(x => !x?.totalAmount ? !x.totalAmount || x.totalAmount <= 0 : 0).length > 0) {
                alert('Load Tarrif First.');
                return false;
            }

            for (const [i, x] of grid.entries()) {
                if (x.shouldTarrifLoad) {
                    alert('Load Tarrif First.');
                    document.getElementById(`LoadTarrif${i + 1}`).focus({ focusVisible: true })
                    return false;
                }
            }
        }
        return true;
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Retail Bulk Booking</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <Form myWorker={worker} validateExcel={validateExcel} />
            {grid && grid.length > 0 && <Grid validateExcel={validateExcel} />}
            {gridStatus && gridStatus.length > 0 && (
                <UploadStatus data={gridStatus} />
            )}
        </div>
    </section>
}

export default RetailBulkBooking;